/* eslint-disable import/no-cycle */
import React from 'react';
import { Text } from '@applane/react-core-components';
import { FormField } from '../../form/field';
import {
  AvatarRender,
  AvatarTextRender,
  CardRender,
  checkBoxRender,
  TextRender,
  TextAreaRender,
  NumberRender,
  OpenActionsRender,
  MoreActionsRender,
  CustomRender,
  RowSelectionRender,
  HeaderRowSelectionRender,
  HeaderTextRender,
  HeaderNumberRender,
  HeaderCustomRender,
  DateRangeRender,
  CurrencyRender,
  RecursiveRender,
  FileRender,
  SwitchRender,
  StatusRender,
  LinkRender,
  ConsultationStatusRender,
} from '../../render-components/ListRenders';
import WithSort from '../sort/WithSort';
import WithAggregate from '../aggregate/WithAggregate';
import { getRenderComponent } from '../../UtilityFunctions';
import {
  customRenderTypes,
  customFooterRenderTypes,
} from './CustomCellRenders';

const renderTypes = {
  default: TextRender,
  custom: CustomRender,
  selection: RowSelectionRender,
  avatar: AvatarRender,
  avatarText: AvatarTextRender,
  card: CardRender,
  moreActions: MoreActionsRender,
  openActions: OpenActionsRender,
  text: TextRender,
  multiText: TextRender,
  textArea: TextAreaRender,
  number: NumberRender,
  date: TextRender,
  time: TextRender,
  file: FileRender,
  checkBox: checkBoxRender,
  autoSuggest: TextRender,
  autoSuggestAvatar: TextRender,
  search: TextRender,
  searchAvatar: TextRender,
  multiAutoSuggest: TextRender,
  multiAutoSuggestAvatar: TextRender,
  multiSearch: TextRender,
  multiSearchAvatar: TextRender,
  googlePlace: TextRender,
  switch: SwitchRender,
  toggle: TextRender,
  toggleSwitch: TextRender,
  radioGroup: TextRender,
  radio: TextRender,
  richText: TextAreaRender,
  progressSlider: TextRender,
  downloadFile: TextRender,
  action: TextRender,
  dateRange: DateRangeRender,
  currency: CurrencyRender,
  recursive: RecursiveRender,
  autoSuggestOptions: TextRender,
  status: StatusRender,
  consultationStatus: ConsultationStatusRender,
  link: LinkRender,
  ...customRenderTypes,
};

const headerTypes = {
  selection: HeaderRowSelectionRender,
  default: HeaderTextRender,
  number: HeaderNumberRender,
  currency: HeaderNumberRender,
  text: HeaderTextRender,
  custom: HeaderCustomRender,
};

let HeaderCellRender = (props) => {
  let { column: { type, headerType } = {} } = props;
  if (headerType) {
    type = headerType;
  }
  if (type && headerTypes[type]) {
    return headerTypes[type](props);
  } else {
    return headerTypes['default'](props);
  }
};
const footerTypes = {
  default: HeaderTextRender,
  number: HeaderNumberRender,
  text: HeaderTextRender,
  currency: HeaderNumberRender,
  custom: HeaderCustomRender,
  ...customFooterRenderTypes,
};

HeaderCellRender = WithSort(WithAggregate(HeaderCellRender));

let FooterCellRender = (props) => {
  let { column: { type, footerType } = {} } = props;
  if (footerType) {
    type = footerType;
  }
  if (type && footerTypes[type]) {
    return footerTypes[type](props);
  } else {
    return footerTypes['default'](props);
  }
};

FooterCellRender = WithSort(WithAggregate(FooterCellRender));

export const CellRender = (props) => {
  const { column, ...restProps } = props;
  const { type, render, Component, componentProps, ...restColumn } = column;
  if (type && renderTypes[type]) {
    return renderTypes[type](props);
  }
  if (Component) {
    return getRenderComponent(Component, {
      ...restProps,
      ...restColumn,
      data: restProps.item,
      ...componentProps,
    });
  } else if (render) {
    return render(props);
  } else {
    return type ? (
      <Text>No type registered : {type}</Text>
    ) : (
      renderTypes['default'](props)
    );
  }
};

export const EditableCellRender = (props) => {
  let { column, navigation, eventDispatcher } = props;
  let { header, editable, valueVisible, ...restColumn } = column;
  if (typeof editable === 'function') {
    editable = editable(props);
  }

  if (valueVisible !== undefined) {
    if (typeof valueVisible === 'function') {
      valueVisible = valueVisible(props);
    }
    if (!valueVisible) {
      return null;
    }
  }
  let { type } = restColumn;
  if (editable === false || type === 'action' || type === 'selection') {
    return CellRender(props);
  } else {
    return (
      <FormField
        variant="standard-compact-unbordered"
        navigation={navigation}
        eventDispatcher={eventDispatcher}
        {...restColumn}
      />
    );
  }
};

export { HeaderCellRender, FooterCellRender };
